export const activeMix = {
  data(){
    return {
      idsActiveElements:[],
      typeAction: null,
      activeElements: null,
    }
  },
  methods:{
    canvasSelectionCreated() {
      this.getSelectionCreated()
    },
    canvasSelectionUpdated() {
      console.log('canvasSelectionUpdated')
      this.getSelectionCreated()
    },
    canvasSelectionCleared() {
      console.log('canvasSelectionCleared')
      this.canvas.discardActiveObject()
      this.typeAction = ''
      this.clearSelectLayout()
    },
    getSelectionCreated() {
      const arr = this.canvas.getActiveObjects()
      if (arr.length === 0) {
        this.typeAction = null
        this.changeActive([])
      } else if (arr.length === 1) {
        let el = this.canvas.getActiveObjects()[0]
        this.typeAction = el.type
        this.changeActive([el.type, true, false, true, el.id, 'white', 1, el.index])
      } else {
        this.typeAction = 'group'
        // this.changeActive(
        //   arr.map(el => [el.type, true, false, true, el.id, 'white', 1, el.index])
        // )
      }
    },
    addLayout(){
      this.layoutsGroup.push({
        name:'И.слой '+this.layoutsGroup.length,
        lock:false,
        show:true,
        active:true,
        objects:[],
        event: {
          type:'none',
          value:0
        }
      })
      this.currentLayoutCroupIndex = this.layoutsGroup.length-1
    },
    changeActiveEl(id) {
      console.log(id)
      let element = this.canvas.getObjects().filter(el => el.id === id[0]);
      console.log(element)
      if (element.length > 0) {
        console.log('boom')
        this.canvas.setActiveObject(element[0])
        this.canvas.renderAll()
      }
    },

  },
  mounted() {
    this.canvas.on('selection:cleared', this.canvasSelectionCleared)
    this.canvas.on('selection:created', this.canvasSelectionCreated)
    this.canvas.on('selection:created', this.canvasSelectionCreated)
    this.canvas.on('selection:updated', this.canvasSelectionUpdated)
  }
}
